import * as React from "react";
import { useState, useEffect, useCallback } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import Loading from "../../components/Loading/Loading";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

import styles from "./PassResetView.module.css"; // Updated to use module.css
import { validatePassword } from "../../util/utilFunctions";

const PassResetView = (props) => {
  const [queryParameters] = useSearchParams();

  const [pageError, setPageError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [formError, setFormError] = useState("");
  const [resetSuccess, setResetSuccess] = useState(false);

  const handleSubmit = useCallback(async () => {
    setFormError("");

    if (!password) {
      setFormError("Please provide a Password");
      return;
    }

    if (!validatePassword(password)) {
      setFormError(
        "Password must be at least 8 characters long, include an uppercase letter, a lowercase letter, and a number."
      );
      return;
    }

    if (!confirmPassword) {
      setFormError("Please confirm the Password");
      return;
    }

    if (password !== confirmPassword) {
      setFormError("Passwords should match");
      return;
    }

    // alert("all correct");
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/auth/reset-pass/new-pass`,
        {
          token: queryParameters.get("token"),
          password: password,
        }
      );

      if (response.status === 200) {
        if (response.data && "success" in response.data) {
          // response data exists
          if (response.data.success) {
            // password reset successful
            // console.log("Pass reset successful");
            // console.log("response: ", response);
            setResetSuccess(true);
          } else {
            // some error in resetting the pass
            var errorMsg = response.data.message
              ? response.data.message
              : "Some error occurred while trying to reset the password!";

            setFormError(errorMsg);
          }
        } else {
          // console.log("API response data error!");
          var errorMsg =
            "Some error occurred while trying to reset the password!";

          setFormError(errorMsg);
        }
      } else {
        var errorMsg = response.data.message
          ? response.data.message
          : "Some error occurred while trying to validate!";
        // console.log("Validation failed!");
        setFormError(errorMsg);
      }
    } catch (error) {
      console.error("Error during resetting password:", error);

      setFormError(
        "Some error occurred while resetting the password. Kindly retry again!"
      );
    }
  }, [password, confirmPassword]);

  useEffect(() => {
    (async () => {
      try {
        const response = await axios.post(
          `${import.meta.env.VITE_BACKEND_URL}/auth/reset-pass/validate`,
          {
            token: queryParameters.get("token"),
          }
        );

        setIsLoading(false);
        if (response.status === 200) {
          if (response.data && "success" in response.data) {
            // response data exists
            if (response.data.success) {
              // validation successful
              // console.log("Validation successful");
              // console.log("response: ", response);
            } else {
              // some error in loggin in user
              var errorMsg = response.data.message
                ? response.data.message
                : "Some error occurred while trying to validate!";

              setPageError(errorMsg);
            }
          } else {
            // console.log("API response data error!");
            var errorMsg = "Some error occurred while trying to validate!";

            setPageError(errorMsg);
          }
        } else {
          var errorMsg = response.data.message
            ? response.data.message
            : "Some error occurred while trying to validate!";
          // console.log("Validation failed!");
          setPageError(errorMsg);
        }
      } catch (error) {
        setIsLoading(false);
        console.error("Error during authentication:", error);

        setPageError(
          "Some error occurred during validation. Kindly retry again!"
        );
      }
    })();

    return () => {};
  }, []);

  return (
    <React.Fragment>
      <Navbar />
      <div className={styles.container}>
        {isLoading ? (
          <div className={styles["buy-and-sell-loading"]}>
            <Loading />
          </div>
        ) : (
          <>
            {pageError ? (
              <div className={styles["page-error"]}>{pageError}</div>
            ) : (
              <div className={styles["reset-container"]}>
                {resetSuccess ? (
                  <>
                    <div className={styles["reset-successful"]}>
                      Your password has been reset successfully!
                    </div>
                    {/* <Link to={"/user"}>
                      <Button
                        variant="contained"
                        size="large"
                      >
                        Login
                      </Button>
                    </Link> */}
                  </>
                ) : (
                  <>
                    <h2 className={styles["login-title"]}>Reset Password</h2>
                    <div className={styles["form-container"]}>
                      <div className={styles["form-component"]}>
                        <TextField
                          id="Password"
                          label="Password"
                          variant="outlined"
                          required
                          type="password"
                          fullWidth
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </div>
                      <div className={styles["form-component"]}>
                        <TextField
                          id="ConfirmPassword"
                          label="Confirm Password"
                          variant="outlined"
                          required
                          type="password"
                          fullWidth
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                      </div>
                      <div
                        className={`${styles["form-component"]} ${styles["pad-t-15"]}`}
                      >
                        <Button
                          variant="contained"
                          onClick={handleSubmit}
                          size="large"
                        >
                          Save
                        </Button>
                      </div>
                      <div className={styles["form-component"]}>
                        {formError ? (
                          <p style={{ color: "red" }}>{formError}</p>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}
          </>
        )}
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default PassResetView;
